import { createElementVNode as _createElementVNode, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xml:space": "preserve",
    x: "0px",
    y: "0px",
    version: "1.1",
    viewBox: "0 0 24 24",
    class: "icon-fi icon-fi-whatsapp"
  }, _ctx.$attrs), _cache[0] || (_cache[0] = [
    _createElementVNode("g", { class: "" }, [
      _createElementVNode("path", {
        d: "M16.1245 15.6249C14.3845 17.3649 10.3755 15.8819 8.37149 13.8779C6.36749 11.8739 4.88449 7.86487 6.62449 6.12487C7.12849 5.62087 7.82249 5.56087 8.24649 5.58087C8.49149 5.59187 8.70349 5.73587 8.84649 5.93587L9.79849 7.26987C9.93593 7.46251 10.0006 7.69765 9.98102 7.93348C9.96143 8.16931 9.85884 8.39056 9.69149 8.55787L8.79049 9.45887C8.95649 9.95887 9.49049 11.1589 10.2905 11.9589C11.0905 12.7589 12.2905 13.2929 12.7905 13.4589L13.6915 12.5589C13.8587 12.3914 14.0799 12.2886 14.3157 12.2688C14.5515 12.249 14.7867 12.3136 14.9795 12.4509L16.3135 13.4029C16.5135 13.5459 16.6575 13.7579 16.6685 14.0029C16.6885 14.4269 16.6285 15.1209 16.1245 15.6249Z",
        class: "icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      }),
      _createElementVNode("path", {
        d: "M11.125 21.625C16.924 21.625 21.625 16.924 21.625 11.125C21.625 5.326 16.924 0.625 11.125 0.625C5.326 0.625 0.625 5.326 0.625 11.125C0.625 13.037 1.136 14.831 2.03 16.375L1.15 21.1L5.875 20.22C7.47049 21.1431 9.28173 21.6278 11.125 21.625Z",
        class: "icon-fi--stroke-linejoin-round icon-fi--no-fill icon-fi--with-stroke"
      })
    ], -1)
  ]), 16))
}
export default { render: render }